import React from "react";
import { Box, Text, HStack, VStack } from "@chakra-ui/react";

interface SponsoredByTuskBadgeProps {
  utmContent?: string;
  size?: "sm" | "md";
}

const TuskIcon = ({ size }: { size: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 500 500"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 230.867V0H367.503V98.9431H98.9431V230.867H0Z" fill="white" />
    <path
      d="M499.427 0H400.484V131.924H131.924V499.427H365.147V263.848H266.204V402.84H230.867V230.867H499.427V0Z"
      fill="white"
    />
  </svg>
);

export const SponsoredByTuskBadge: React.FC<SponsoredByTuskBadgeProps> = ({
  utmContent = "homepage",
  size = "md",
}) => {
  const handleClick = () => {
    window.open(
      `https://www.usetusk.ai/?utm_source=sbpropbets&utm_content=${utmContent}`,
      "_blank"
    );
  };

  const isSmall = size === "sm";
  const iconSize = isSmall ? 12 : 14;
  const mainFontSize = isSmall ? "sm" : "md";
  const taglineFontSize = isSmall ? "xs" : "sm";
  const paddingX = isSmall ? 3 : 4;
  const paddingY = isSmall ? 1.5 : 2;

  return (
    <Box
      onClick={handleClick}
      cursor="pointer"
      bg="#B100FF"
      borderRadius="lg"
      px={paddingX}
      py={paddingY}
      display="inline-block"
      boxShadow="md"
      _hover={{ bg: "#8B4CF7" }}
      transition="background 0.2s"
    >
      <VStack spacing={isSmall ? 0.25 : 0.5} align="center">
        <HStack spacing={1.5}>
          <TuskIcon size={iconSize} />
          <Text fontSize={mainFontSize} fontWeight="extrabold" color="white">
            Sponsored by Tusk
          </Text>
        </HStack>
        <Text fontSize={taglineFontSize} color="white">
          The next frontier of code review
        </Text>
      </VStack>
    </Box>
  );
};
